import { Dispatch } from "redux";
import { getToken } from "services/token.service";
import { DamperData, DamperUpdate, DamperFetchSettings } from "models";
import { GET_DAMPERS } from "endpoints";

const configuration = (window as any).configuration;
const AWS_URL = configuration.awsUrl;

export enum DampersActions {
  SetDamperConfigs = "dampers/set_damper_configs",
  FetchingDamperConfigs = "dampers/fetching_damper_configs",
  FetchDamperConfigsSuccessful = "dampers/fetch_damper_configs_successful",
  FetchingDamperConfigsFailed = "dampers/fetch_damper_configs_failed",
  UpdateDamperValue = "dampers/update_damper_value",
  ToggleOverride = "dampers/toggle_override",
  ToggleOverrideAll = "dampers/toggle_override_all",
}

// SetDamperConfigs

export interface SetDamperConfigsAction {
  type: DampersActions.SetDamperConfigs;
  payload: { damperData: DamperData[]; reloadDampers: boolean };
}

export const setDamperConfigs = (damperData: DamperData[] | [], reloadDampers: boolean): SetDamperConfigsAction => {
  return {
    type: DampersActions.SetDamperConfigs,
    payload: { damperData, reloadDampers },
  };
};

// FetchingDamperConfigs

export interface FetchingDamperConfigsAction {
  type: string;
  payload: DamperFetchSettings;
}

const fetchingDamperConfigs = (fetchTime: string, fetchLineId: string): FetchingDamperConfigsAction => {
  return {
    type: DampersActions.FetchingDamperConfigs,
    payload: { fetchTime, fetchLineId },
  };
};

// FetchingDamperConfigsFailed

export interface FetchingDamperConfigsFailedAction {
  type: string;
}

const fetchingDamperConfigsFailed = (): FetchingDamperConfigsFailedAction => {
  return {
    type: DampersActions.FetchingDamperConfigsFailed,
  };
};

// UpdateDamperValue

export interface UpdateDamperValueAction {
  type: string;
  payload: DamperUpdate;
}

export const UpdateDamperValue = (damperUpdate: DamperUpdate): UpdateDamperValueAction => {
  return {
    type: DampersActions.UpdateDamperValue,
    payload: damperUpdate,
  };
};

// ToggleOverrideAll

export interface ToggleOverrideAllAction {
  type: string;
  payload: boolean;
}

export const ToggleOverrideAll = (override: boolean): ToggleOverrideAllAction => {
  return {
    type: DampersActions.ToggleOverrideAll,
    payload: override,
  };
};

export type DampersActionTypes =
  | FetchingDamperConfigsAction
  | FetchingDamperConfigsFailedAction
  | SetDamperConfigsAction
  | ToggleOverrideAllAction
  | UpdateDamperValueAction;

export const fetchDampersData = (millId: string, lineId: string, startTime: string, endTime: string, reload: boolean) => {
  return async (dispatch: Dispatch) => {
    dispatch(fetchingDamperConfigs(startTime, lineId));

    try {
      const token = await getToken();

      const response = await fetch(AWS_URL + GET_DAMPERS, {
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: token as string,
        }),
        method: "post",
        body: JSON.stringify({ millId, lineId, startTime, endTime }),
      });

      if (!response.ok) {
        const errorMsg = await response.text();
        throw new Error(errorMsg);
      }

      const damperData = await response.json();

      dispatch(setDamperConfigs(damperData, reload));
    } catch (error) {
      console.error(error);
      dispatch(fetchingDamperConfigsFailed());
    }
  };
};
